import React, { useEffect } from 'react'

// bootstrap
import {
    Image
} from 'react-bootstrap'

// styles
import {
    CategoriesContainer,
    HeaderContainer,
    H1,
    PageLinkDiv,
    LinkDiv
} from './styles/CategoriesStyles'

// no image
import noImgFoundImg from 'assets/images/no-img.png'

// react router
import { Link } from 'react-router-dom'

import LoadingSkeleton from "./Categories__loadingSkeleton";

export default function CategoriesTheme1(props) {
    // props
    const { currentRoute, categoriesListLoading, categoriesList, } = props

    // consts
    const loadingIndicatorsCount = [1, 2, 3, 4, 5, 6]

    return (
        <CategoriesContainer>
            <div className="container">
                <div className="categories-main row">
                    <div className="col-12 breadcrumbs">
                        <HeaderContainer>
                            {/* Dynamic name */}
                            <H1>{currentRoute?.routeName}</H1>
                            <PageLinkDiv
                                className="ec-breadcrumbs"
                                aria-label="Breadcrumbs"
                                role="region"
                            >
                                <LinkDiv href="">Categories</LinkDiv>&ensp;/&ensp;
                                <LinkDiv href={currentRoute?.routeName} className="text-uppercase">
                                    {currentRoute?.routeName}
                                </LinkDiv>
                            </PageLinkDiv>
                        </HeaderContainer>
                    </div>
                    {
                        categoriesListLoading ? (
                            <React.Fragment>
                                {
                                    (loadingIndicatorsCount?.length) ? loadingIndicatorsCount.map(item => (
                                        <React.Fragment key={item}>
                                            <LoadingSkeleton />
                                        </React.Fragment>
                                    )) : null
                                }
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                {
                                    /* item */
                                    categoriesList?.length ? categoriesList.map(item => (
                                        <div key={item.category_id} className="item col-md-4 col-lg-3">
                                            <Link to={`/shop/${item.category_url}?id=${item.category_id}`} className="inner text-center d-block text-decoration-none">
                                                {/* img sec */}
                                                <div className="img-sec-outer">
                                                    <div className="img-sec" data-item={item.image}>
                                                        <Image src={item.image || noImgFoundImg} fluid onLoad={ev => ev.target.parentNode.classList.add("loaded")} />
                                                    </div>
                                                </div>

                                                {/* text sec */}
                                                <div className="text-sec mt-3">
                                                    <p className="cat-name mb-0 st-fw-600 st-fs-18 text-uppercase">
                                                        {item.category_name}
                                                    </p>
                                                </div>
                                            </Link>
                                        </div>
                                    )) : (
                                        <React.Fragment>
                                            <div className="text-center py-2">
                                                No sub categories found
                                            </div>
                                        </React.Fragment>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </div>
            </div>
        </CategoriesContainer>
    )
}
